import './owned-topics-tab.styles.scss'
import { InputWithLabel } from '@winnin/winnin_ui.components.input-with-label'
import { Loading } from '@winnin/winnin_ui.components.loading'
import { Title } from '@winnin/winnin_ui.components.title'

import { BaseSkeleton } from 'components/BaseSkeleton'
import LoadingErrorWrapper from 'components/LoadingErrorWrapper'
import { T, useTranslate } from 'lib/tolgee'
import { TOLGEE_GLOBALS } from 'utils'

import { OwnedTopicsTable } from '../owned-topics-table'
import type { IOwnedTopicsTab } from './owned-topics-tab.types'

export const OwnedTopicsTabView = ({
  handleChange,
  handleSubmit,
  isLoading,
  sentryRef,
  tableData,
  error,
  hasMore,
  isFetchingMore,
  refetch,
  searchFilter,
  totalPagination,
}: IOwnedTopicsTab) => {
  const t = useTranslate()
  return (
    <div className="OwnedTopicsTab">
      <div className="filtersSection">
        {isLoading ? (
          <BaseSkeleton height={12} borderRadius={20} width={150} />
        ) : (
          <Title tag="h3">
            <T
              keyName={TOLGEE_GLOBALS.results.key}
              parameters={{
                results: totalPagination ?? 0,
              }}
            >
              {`${TOLGEE_GLOBALS.results.defaultValue}`}
            </T>
          </Title>
        )}
        <form onSubmit={handleSubmit}>
          <InputWithLabel
            onChange={e => handleChange(e.target.value)}
            value={searchFilter}
            name="searchInput"
            placeholder={t({
              key: `AddToJobFolderModalContent-search`,
              defaultValue: 'Search',
            })}
          />
        </form>
      </div>

      <LoadingErrorWrapper loading={isLoading} isEmpty={tableData?.length === 0} error={error} refetch={refetch}>
        {tableData?.length > 0 && (
          <>
            <OwnedTopicsTable tableData={tableData} />
            {(isFetchingMore || hasMore) && (
              <div ref={sentryRef}>
                <Loading />
              </div>
            )}
          </>
        )}
      </LoadingErrorWrapper>
    </div>
  )
}
